import { Pivot, PivotItem } from '@fluentui/react';
import React from 'react';
import CompanyManagementDisplay from '../../components/Contacts/CompanyManagementDisplay';
import ContactsManagementDisplay from '../../components/Contacts/ContactsManagementDisplay';
import ImportActivityDisplay from '../../components/Contacts/ImportActivityDisplay';
import { useUrlTabState } from '../../hooks/useUrlState';

const ContactManagementPage: React.FC = () => {
    // 'push' keeps this screen's existing Back behavior, which stepped back through tabs.
    const [selectedTab, onTabChange] = useUrlTabState('companies', { historyMode: 'push' });

    return (
        <div>
            <h1>Contact Management</h1>
            <Pivot
                styles={{itemContainer:{paddingTop: '1em'}}}
                selectedKey={selectedTab}
                onLinkClick={(item) => onTabChange(item?.props.itemKey)}
            >
                <PivotItem headerText='Companies' itemKey='companies'>
                    <CompanyManagementDisplay />
                </PivotItem>
                <PivotItem headerText='Contacts' itemKey='contacts'>
                    <ContactsManagementDisplay />
                </PivotItem>
                <PivotItem headerText='Activity' itemKey='activity'>
                    <ImportActivityDisplay />
                </PivotItem>
            </Pivot>
        </div>
    );
}

export default ContactManagementPage;
